import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import ModalAddFile from '../Shared/ModalAddFile'
import BoxButton from '../Layout/BoxButton'
import SelectorInput from '../Shared/SelectorInput'

import { showModalSelector, selectFromSelector } from '../../actions/common'

import { displayModalAddFile } from '../../actions/common'
import {
    displayModalCompraDirecta,
    updateInputs,
    addFileCompraDirecta,
    createOrUpdateCompraDirecta,
} from '../../actions/solicitudservicio'

class ModalCreateCompraDirecta extends Component {


    handleOpenSelectorProveedor = (path) => {
        let columns = [
            { id: 2, caption: 'Nombre', value: 'nombre', width: '100%' }
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = path
            payload.value = a
            
            this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_SERVICIO1', payload)
        }
        this.props.showModalSelector('Listado de proveedores', columns, '/proveedores_externos', fn)
    }

	handleCloseModal = (e) => {

		const modal = document.getElementById('modalCreateCompraDirecta')
		modal.classList.remove('fadeIn')
		modal.classList.add('fadeOut')

		const modalDialog = document.querySelector(`#modalCreateCompraDirecta .modal-dialog`)
		modalDialog.classList.remove('zoomIn')
		modalDialog.classList.add('zoomOut')

		setTimeout(() => this.props.displayModalCompraDirecta(false, '', ''), 300)
    }
 

	render() {
        
        const { modalCreateCompraDirecta, updateInputs } = this.props
		if (!modalCreateCompraDirecta.get('show')) {
			return null
         }

 

		return(
			<Modal id="modalCreateCompraDirecta" show={ true } ZIndex={ 2000 } >

                <form id="form" onSubmit={ e => { e.preventDefault(); this.props.createOrUpdateCompraDirecta() }} noValidate>

					<ModalHeader title={ modalCreateCompraDirecta.get('title') } onClose={ (e) => this.handleCloseModal(e) } />                     

					<ModalButtonStrip>   
                        <BoxButton name="floppy-o" disabled={ modalCreateCompraDirecta.get('btnDisabled') } title="Guardar" />
					</ModalButtonStrip>

					<ModalBody >
						<div style={{ width: '70vw', height: '60vh' }}>
                            <div className="content">
                                <div className="col-md-8">
                                    <div className="form-group">
                                        <label htmlFor="" className="control-label">Producto comprado</label>
                                        <input type="text" className="form-control input-sm" defaultValue={modalCreateCompraDirecta.get('servicio_descripcion')} disabled={true}/>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="" className="control-label">Cantidad</label>
                                        <input type="number" className="form-control input-sm" defaultValue={modalCreateCompraDirecta.get('servicio_cantidad')} disabled={true}/>
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label className="control-label">Seleccionar proveedor existente</label>
                                        <SelectorInput 
                                            value={ modalCreateCompraDirecta.getIn(['data', 'proveedor', 'nombre']) || '' } 
                                            onClick={ () => this.handleOpenSelectorProveedor('modalCreateCompraDirecta.data.proveedor') } 
                                            onReset={ () => this.props.updateInputs('modalCreateCompraDirecta.data.proveedor', null) }
                                        />
                                    </div>   
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="" className="control-label">Proveedor nuevo</label>
                                        <input type="text" className="form-control input-sm" value={modalCreateCompraDirecta.getIn(['data', 'razon_social'])}
                                            onChange={ (e) => updateInputs('modalCreateCompraDirecta.data.razon_social', e.target.value)} />
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="" className="control-label">No. Factura</label>
                                        <input type="text" className="form-control input-sm" value={modalCreateCompraDirecta.getIn(['data', 'no_factura'])}
                                            onChange={ (e) => updateInputs('modalCreateCompraDirecta.data.no_factura', e.target.value)}/>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="" className="control-label">Fecha Compra</label>
                                         <input type="date" className="form-control input-sm" value={modalCreateCompraDirecta.getIn(['data', 'fecha_compra'])}
                                            onChange={ (e) => updateInputs('modalCreateCompraDirecta.data.fecha_compra', e.target.value)}/>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="" className="control-label">Forma de Pago</label>
                                        <select value={modalCreateCompraDirecta.getIn(['data', 'medio_pago'])} className="form-control input-sm"
                                            onChange={ (e) => updateInputs('modalCreateCompraDirecta.data.medio_pago', e.target.value)}>
                                            <option value="" disabled>Seleccione forma de pago</option>
                                            <option value="tarjeta_debito">Tarjeta débito</option>
                                            <option value="tarjeta_credito">Tarjeta crédito</option>
                                            <option value="caja_menor">Caja menor</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="" className="control-label">Valor compra</label>
                                        <input type="number" className="form-control input-sm" value={modalCreateCompraDirecta.getIn(['data', 'valor_compra'])}
                                            onChange={ (e) => updateInputs('modalCreateCompraDirecta.data.valor_compra', e.target.value)}/>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label className="control-label">
                                            Adjuntar factura
                                        </label>
                                        <label className={`form-control input-sm label-upload-file label-upload-file-enabled`} onClick={ () => this.props.displayModalAddFile(true, 'Adjuntar archivo', 'create')} >
                                            <i className="fa fa-upload"></i> { modalCreateCompraDirecta.getIn(['data','adjunto','file']) ? modalCreateCompraDirecta.getIn(['data','adjunto','file']).name : ' Seleccione un archivo...' }
                                        </label>
                                    </div>                             
                                </div>
                            </div>
						</div>
					</ModalBody >
					<ModalFooter >
					</ModalFooter>
				</form>
                <ModalAddFile
                    action={ () => this.props.addFileCompraDirecta('modalCreateCompraDirecta.data.adjunto') }
                />
			</Modal>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		modalCreateCompraDirecta: state.solicitudservicio.get('modalCreateCompraDirecta'),
        enums: state.common.get('enums').toJS(),
        documento_origen: state.solicitudservicio.getIn(['solicitud', 'documento_origen']),
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
        showModalSelector: (title, fields, url, action, customFilter) => dispatch(showModalSelector(title, fields, url, action, customFilter)),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
		displayModalCompraDirecta: (show, title, mode) => dispatch(displayModalCompraDirecta(show, title, mode)),
        displayModalAddFile: (show, title, mode, index) => dispatch(displayModalAddFile(show, title, mode, index)),
        addFileCompraDirecta: (path) => dispatch(addFileCompraDirecta(path)),
		updateInputs: (path, value, immutable) => dispatch(updateInputs(path, value, immutable)),
        createOrUpdateCompraDirecta: () => dispatch(createOrUpdateCompraDirecta()),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreateCompraDirecta)



// WEBPACK FOOTER //
// ./src/components/SolicitudServicio/ModalCreateCompraDirecta.jsx